export default {
  FETCH_BENEFITS: "FETCH_BENEFITS",
  INITIALIZE_PROFILE: "INITIALIZE_PROFILE",
  PROFILE_CHANGE: "PROFILE_CHANGE",
  PROFILE_SAVING: "PROFILE_SAVING",
  PROFILE_SAVED: "PROFILE_SAVED",
  PROFILE_UNSAVED: "PROFILE_UNSAVED",
  PROFILE_SAVE_ERROR: "PROFILE_SAVE_ERROR",
  CLOSE_WELCOME: "CLOSE_WELCOME",
  CHANGE_SECTION: "CHANGE_SECTION"
};



// WEBPACK FOOTER //
// ./src/advocate/onboarding/constants.js